// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Note-module__root--vFWLV {
  box-sizing: border-box;
  display: block;
  width: 100%;
  min-height: 54px;
  padding: 12px 0 12px 16px;
  position: relative;
  color: var(--chaek-color-text-secondary);
  font-family: var(--chaek-font-family-gowun-dodum);
  font-size: 1rem; /* 16px */
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.7625px;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
}

.Note-module__root--vFWLV::before,
.Note-module__root--vFWLV::after {
  display: inline-block;
  height: 24px;
  color: var(--chaek-color-text-primary);
  content: '"';
  font-size: 2rem; /* 32px */
  font-weight: 400;
  line-height: 1.2;
  letter-spacing: -0.35px;
  vertical-align: top;
}

.Note-module__root--vFWLV::before {
  position: absolute;
  top: 8px;
  left: 0;
}

.Note-module__root--vFWLV::after {
  margin-left: 4px;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/Note/Note.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;EACxC,iDAAiD;EACjD,eAAe,EAAE,SAAS;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;EACrB,YAAY;EACZ,sCAAsC;EACtC,YAAY;EACZ,eAAe,EAAE,SAAS;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;AACT;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".root {\n  box-sizing: border-box;\n  display: block;\n  width: 100%;\n  min-height: 54px;\n  padding: 12px 0 12px 16px;\n  position: relative;\n  color: var(--chaek-color-text-secondary);\n  font-family: var(--chaek-font-family-gowun-dodum);\n  font-size: 1rem; /* 16px */\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.7625px;\n  overflow-wrap: anywhere;\n  white-space: pre-wrap;\n}\n\n.root::before,\n.root::after {\n  display: inline-block;\n  height: 24px;\n  color: var(--chaek-color-text-primary);\n  content: '\"';\n  font-size: 2rem; /* 32px */\n  font-weight: 400;\n  line-height: 1.2;\n  letter-spacing: -0.35px;\n  vertical-align: top;\n}\n\n.root::before {\n  position: absolute;\n  top: 8px;\n  left: 0;\n}\n\n.root::after {\n  margin-left: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Note-module__root--vFWLV`
};
export default ___CSS_LOADER_EXPORT___;
